import React, { useRef, useEffect, useState } from "react";

function ErrorItem(props) {
  const focusRef = useRef();
  const [focusError, setFocusError] = useState(false);

  useEffect(() => {
    if (!focusError) {
      focusRef.current.focus();
      setFocusError(true);
    }
  }, [focusError]);

  return (
    <div className="ugc-error-message">
      <div
        className="error-message-top error-message-top--visible"
        role="alert"
        key={props.index}
        ref={focusRef}
        tabIndex="0">
        {props.error.errorMessage}
      </div>
    </div>

  );
}

export default ErrorItem;
